import {
  Box,
  Text,
  Heading,
  Stack,
  Flex,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { FC, Fragment, ReactNode } from "react";
import { tableStyles } from "../../../utils/styles/tableStyles";
import Pagination from "../../../components/organism/Pagination/Pagination";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import { PAGE_SIZE_OPTIONS } from "../../../utils/constants";
import getReferenceTextHelper from "../../../helpers/Indicator/getReferenceTextHelper";
import { renderLoadingState } from "../../../hooks/table/TableStates";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";

interface ModalBodyIndicatorProps {
  control: any;
  tableConfig: TableConfig;
  paginationConfig: PaginationConfig;
  isHistoryLoaded: boolean;
}

const ModalBodyIndicator: FC<ModalBodyIndicatorProps> = ({
  control,
  tableConfig,
  paginationConfig,
  isHistoryLoaded,
}) => {
  const { tableName = "Lista de Itens", dataTable } = tableConfig;
  const {
    pageSize,
    currentPage,
    totalPages,
    handlePageChange,
    renderContent,
    setPageSize,
    totalItems,
  } = paginationConfig;

  const details: { label: string; value: ReactNode }[] = [
    {
      label: "Nome do indicador:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.indicator?.name || "-"}
        </Text>
      ),
    },
    {
      label: "Sub-sistema:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.indicator?.subSystem?.name || "-"}
        </Text>
      ),
    },
    {
      label: "Frequência de recolha:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.indicator?.frequency?.name || "-"}
        </Text>
      ),
    },
    {
      label: "Referências do indicador:",
      value: (
        <Text whiteSpace="nowrap">
          {getReferenceTextHelper(control._formValues.row?.indicator)}
        </Text>
      ),
    },
    {
      label: "Nível:",
      value: (
        <Text whiteSpace="nowrap">
          {control._formValues.row?.level?.name || "-"}
        </Text>
      ),
    },
  ];

  return (
    <Stack gap="8">
      <Stack gap="4">
        <Heading as="h4" fontSize="xl">
          Dados do indicador
        </Heading>
        <Grid
          templateColumns={{ base: "1fr", md: "max-content 1fr" }}
          columnGap={{ base: 0, md: 6 }}
          rowGap={2}
        >
          {details.map(({ label, value }) => (
            <Fragment key={label}>
              <GridItem>
                <Text fontWeight="bold" whiteSpace="nowrap">
                  {label}
                </Text>
              </GridItem>
              <GridItem>{value}</GridItem>
            </Fragment>
          ))}
        </Grid>
      </Stack>
      {isHistoryLoaded ? (
        <Stack gap="4">
          <Flex
            direction="row"
            gap="4"
            justifyContent="space-between"
            alignItems="center"
          >
            <Heading as="h4" fontSize="xl">
              {tableName}
            </Heading>
            <Pagination
              totalResults={totalItems ? totalItems : dataTable.length}
              pageSizeOptions={PAGE_SIZE_OPTIONS}
              totalPages={totalPages}
              currentPage={currentPage}
              pageSize={pageSize}
              handlePageChange={handlePageChange}
              setPageSize={setPageSize}
            />
          </Flex>
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            sx={tableStyles}
          >
            {renderContent()}
          </Box>
        </Stack>
      ) : (
        <Box border={borderStyle} borderBottomRadius={borderRadius} padding="3">
          {renderLoadingState()}
        </Box>
      )}
    </Stack>
  );
};

export default ModalBodyIndicator;
